import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

export const CurrencyWithPlaceholderFallback = ({
    value
}: {
    value: number | null;
}) => (value !== null ? <FormattedCurrency value={value} /> : <>--,-- €</>);
